<template>
  <div class="g-big">
    <!-- <a
      :href="'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id='+ this.data.article_id +'&page='+this.index+'&columnId='+this.columnId"
      class="m-bigTitle"
    >{{this.data.title}}</a> -->
    <router-link :to="'/article/' + this.data.articles[0].article_id"
      :class="'m-bigTitle ' + this.data.articles[0].title_font_size" tag="div" v-if="this.data.articles[0].article_id != null">
      <div v-html="this.Breaks(this.data.articles[0].title)"></div>
    </router-link>

    <a :href="this.data.articles[0].article_url"  :class="'m-bigTitle ' + this.data.articles[0].title_font_size"  v-else >
      <div v-html="this.Breaks(this.data.articles[0].title)"></div>
    </a>



    <div :class="'m-disc ' + this.data.articles[0].sub_title_font_size" v-if="this.data.articles[0].sub_title != ''"
      v-html="this.Breaks(this.data.articles[0].sub_title)">

    </div>

    <!-- <a
      :href="'http://www.nbd.com.cn/corp/2019newspaper/tongweiArticle.html?article_id='+ this.data.article_id +'&page='+this.index+'&columnId='+this.columnId"
      class="m-imgBox"
    >
      <img v-bind:src="this.data.image.replace('image.nbd.com.cn','www.nbd.com.cn')" alt class="u-bigImg" />
      
    </a> -->
    <router-link :to="'/article/' + this.data.articles[0].article_id" class="m-imgBox"
      v-if="this.data.articles[0].article_type == 1 && this.data.articles[0].article_id != null">
      <img :id="'img' + index" v-bind:src="getImage(this.data.articles[0].cover_img, 'img' + index)" alt
        class="u-bigImg" />
    </router-link>
    <a :href="this.data.articles[0].article_url"  :class="'m-bigTitle ' + this.data.articles[0].title_font_size"  v-else-if="this.data.articles[0].article_type == 1 && this.data.articles[0].article_id == null" >
      <img :id="'img' + index" v-bind:src="getImage(this.data.articles[0].cover_img, 'img' + index)" alt
        class="u-bigImg" />
    </a>
    <video v-else-if="this.data.articles[0].article_type == 2" :src="this.data.articles[0].multimedia_url"
      class="m-imgBox" controls :poster="this.data.articles[0].cover_img" v-show="!showCoverImg"></video>
    <!-- <video v-else-if="this.data.articles[0].article_type == 2" :src="this.data.articles[0].multimedia_url"
      class="m-imgBox" controls :poster="this.data.articles[0].cover_img" v-show="!showCoverImg"></video>
    <iframe v-else-if="this.data.articles[0].article_type == 3" :src="this.data.articles[0].multimedia_url"
      class="m-imgBox" v-show="!showCoverImg" allowfullscreen="true"></iframe> -->
    <iframe v-else-if="this.data.articles[0].article_type == 3 && this.data.articles[0].multimedia_type != 1" :src="this.data.articles[0].multimedia_url"
      class="m-imgBox" v-show="!showCoverImg" allowfullscreen="true"></iframe>
    <div class="prism-player m-imgBox" id="player-con" v-else-if="this.data.articles[0].article_type == 3 && this.data.articles[0].multimedia_type == 1"></div>
    <div class="m-imgBox" v-if="this.data.articles[0].article_type != 1" v-show="showCoverImg">
      <img :id="'img' + index" v-bind:src="getImage(this.data.articles[0].cover_img, 'img' + index)" alt
        class="u-bigImg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "bingImage",
  props: {
    type: [Number, String],
    data: Object,
    index: [Number, String],
    columnId: [Number, String],
    showCoverImg: [Boolean],
  },
  data() {
    return {
      base64: "",
    };
  },
  methods: {
    getImage: function (url, imgId) {
      console.log(imgId)
      var xhr = new XMLHttpRequest();
      xhr.open("get", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (this.status == 200) {
          document.getElementById(imgId).src = URL.createObjectURL(
            this.response
          );
        }
      };
      xhr.send(null);
    },
  },
  mounted() {
    let that = this
    let source_url = that.data.articles[0].multimedia_url
    console.log(source_url)
    if ( this.data.articles[0].article_type == 3 && this.data.articles[0].multimedia_type == 1) {
      var player = new Aliplayer({
        "id": "player-con",
        "source": source_url,
        "width": "100%",
        "height": "500px",
        "autoplay": false,
        "isLive": true,
        "rePlay": false,
        "playsinline": true,
        "preload": true,
        "controlBarVisibility": "hover",
        "useH5Prism": true
      }, function (player) {
        console.log("The player is created");
      }
      );
    }

  }
};
</script>
<style lang="scss">
.g-big {
  // overflow: hidden;
  // margin-top: 0.466667rem;
  flex-shrink: 1;
  -ms-flex-shrink: 1;
}

.m-bigTitle {
  font-size: 0.72rem;
  font-weight: bolder;
  text-align: center;
  display: block;
  color: #000;
}

.m-disc {
  font-size: 0.32rem;
  color: #000;
  text-align: center;
}

.m-imgBox {
  width: 100%;
  margin-top: 0.133333rem;
  overflow: hidden;
  position: relative;
  display: block;
  height: 4.96rem !important;
  flex-shrink: 1;

  img {
    max-width: 100%;
  }
}

.m-imgBox2,
.m-imgBox3 {
  width: 100%;
  margin-top: 0.333333rem;
  overflow: hidden;
  position: relative;
  display: block;
  height: 5.106667rem;

  img {
    max-width: 100%;
  }
}

.m-imgBox3 {
  height: 3.8rem;
}

.m-imgMsg {
  height: 1rem;
  background: #274595;
  width: 100%;

  span {
    color: #fff;
    float: left;
    width: 1rem;
    height: 1rem;
    font-size: 0.24rem;
    text-align: center;
    background: #e22000;
  }

  p {
    padding-left: 1.2rem;
    font-size: 0.32rem;
    color: #fff;
    height: 1rem;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    b {
      font-size: 0.493333rem;
      font-weight: bolder;
    }
  }
}

.u-bigImg {
  display: block;
  max-width: 100%;
}

.u-icon1 {
  display: inline-block;
  width: 0.32rem;
  height: 0.253333rem;
  margin-top: 0.5rem;
  margin-right: 0.1rem;
}

.u-icon11 {
  width: 1rem;
  height: 1rem;
  float: left;
}

.u-iconTrend {
  width: 2.653333rem;
  height: 0.733333rem;
  position: absolute;
  right: 0;
  top: 0.133333rem;
}
</style>